module.exports = __webpack_public_path__ + "media/assets/img/flags/fr-90e6a1e097f7bb27eaab27e694e40300.png";